import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="url-updater"
export default class extends Controller {
  updateUrl(event) {
    // Only update URL if the form submission was successful
    if (event.detail.success) {
      const form = this.element
      const formData = new FormData(form)
      const searchParams = new URLSearchParams()

      // Build query string from form data, excluding the format parameter
      for (const [key, value] of formData.entries()) {
        if (key !== 'format' && value !== '') {
          searchParams.append(key, value)
        }
      }

      // Get the current path (without query string)
      const currentPath = window.location.pathname

      // Build new URL with search parameters
      const newUrl = searchParams.toString()
        ? `${currentPath}?${searchParams.toString()}`
        : currentPath

      // Update the browser URL without triggering navigation
      window.history.pushState({}, '', newUrl)
    }
  }
}
